(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    var nodes = document.querySelectorAll('[data-lyb-reveal]');
    if (!nodes.length || reduce || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('lyb-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    nodes.forEach(function (n) {
      if (n.getBoundingClientRect().top < window.innerHeight * 0.9) { n.classList.add('is-in'); return; }
      io.observe(n);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // the theme editor re-renders sections in place; reveal them straight away there
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-lyb-reveal]').forEach(function (n) { n.classList.add('is-in'); });
  });
})();
